import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderGoogleCalendarCommon = {
  key: 'googleCalendar',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'googleCalendar',
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    tokenUrl: 'https://oauth2.googleapis.com/token',
    scopes: ['email', 'https://www.googleapis.com/auth/userinfo.profile'],
    authParams: {
      include_granted_scopes: true,
    },
  }),
}

export type ProviderGoogleCalendarAccountType = {
  email: string
  name: string
}

export enum GoogleCalendarScope {
  Manage = 'https://www.googleapis.com/auth/calendar',
}
